export default __webpack_public_path__ + "static/media/accordionchevron.019fd631.svg";